export enum LogLevel {
    INFO = 'INF',
    ERROR = 'ERR',
    DEBUG = 'DBG'
}
